<template>
  <MainAsideRightHead
    title="Настройки  команды"
    store-path="usersGroupsUsers"
    :can-save="canSave"
    :options-visible="false"
    save-text="Сохранить"
    @save="save"
  ></MainAsideRightHead>
</template>

<script>
import MainAsideRightHead from '@/components/MainAsideRight/MainAsideRightHead';
import { mapState } from 'vuex';

export default {
  components: { MainAsideRightHead },
  computed: {
    ...mapState('usersTeamMembers', {
      canSave: s => s.aside.meta.canSave,
      team: s => s.data.team,
      user: s => s.aside.data.user,
      step: s => s.aside.meta.step,
      stagedUser: s => s.aside.data.stagedUser,
      isCaptain: s => s.aside.data.notUsual.isCaptain,
      isLeader: s => s.aside.data.notUsual.isLeader,
      folder: s => s.data.folder
    }),
    ...mapState('users', {
      userId: s => s.data.userId
    })
  },
  methods: {
    async save() {
      if (!this.canSave) {
        return;
      }

      this.$store.dispatch('usersTeamMembers/setAsideData', {
        path: 'canSave',
        value: false
      });

      // await this.$store.dispatch('usersGroupsUsers/setAsideData',{path: 'stagedUsers', value:[{id: this.userId}]})
      // await this.$store.dispatch('usersGroupsUsers/addUsers',{groupId:this.folder})

      //   if(this.user.id)
      //   this.$store.dispatch('usersTeamMembers/editUser',{teamId: this.$route.params.teamId})
      // else
      this.$store.dispatch('usersTeamMembers/saveTeam', {
        teamId: this.$route.params.teamId
      });

      this.closeAside();
    },
    closeAside() {
      this.$store.dispatch('usersTeamMembers/setAsideMeta', {
        path: 'forceClose',
        value: true
      });
    }
  }
};
</script>
